import { Pagination } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiArrowUpRight, FiClock } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { fetchPosts } from '../../../api/post';
import s from './PostList.module.css';

const PostList = () => {
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const pageSize = 6;
    const { t, i18n } = useTranslation();
    const language = i18n.resolvedLanguage?.startsWith('zh') ? 'zh' : 'en';

    useEffect(() => {
        let active = true;

        const loadPosts = async () => {
            setLoading(true);
            setError(false);
            try {
                const response = await fetchPosts(page, pageSize, language);
                const data = response.data.data;
                if (active) {
                    setPosts(data.content || []);
                    setTotal(data.totalElements || 0);
                }
            } catch (loadError) {
                if (active) setError(true);
            } finally {
                if (active) setLoading(false);
            }
        };

        loadPosts();
        return () => { active = false; };
    }, [page, language]);

    useEffect(() => {
        setPage(1);
    }, [language]);

    return (
        <section className={s.postsSection} aria-live="polite">
            {loading && <div className={s.state}>{t('writing.loading')}</div>}
            {!loading && error && <div className={s.state}>{t('writing.error')}</div>}
            {!loading && !error && posts.length === 0 && <div className={s.state}>{t('writing.empty')}</div>}

            {!loading && !error && posts.length > 0 && (
                <div className={s.postGrid}>
                    {posts.map((post, index) => (
                        <article className={s.postCard} key={post.id}>
                            <Link to={`/post/${post.id}`}>
                                <div className={s.postMeta}>
                                    <span>{String((page - 1) * pageSize + index + 1).padStart(2, '0')}</span>
                                    <span><FiClock /> {t('Date')}: {dayjs(post.date).format('YYYY-MM-DD')}</span>
                                </div>
                                <h2>{post.title}</h2>
                                <p>{post.summary}</p>
                                <span className={s.readMore}>{t('writing.readArticle')} <FiArrowUpRight /></span>
                            </Link>
                        </article>
                    ))}
                </div>
            )}

            {total > pageSize && (
                <div className={s.pagination}>
                    <Pagination current={page} pageSize={pageSize} total={total} showSizeChanger={false} onChange={setPage} />
                </div>
            )}
        </section>
    );
};

export default PostList;
